/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RsaDeviceListResponse } from '../../models/rsa-device-list-response';

export interface GetRsaDevices$Params {

/**
 * Pagination parameter. Skips page * size entries.
 */
  page?: number;

/**
 * Max number of results per page.
 */
  size?: number;

/**
 * Paramter to sort by as field(:(asc|desc))?. If missing default sort is used. field is the name in the db model not the db field name.
 */
  sort?: Array<string>;

/**
 * include only devices connected to specified branch.
 */
  branch_id?: string;

/**
 * If true will return also disabled devices.
 */
  include_disabled?: boolean;
}

export function getRsaDevices(http: HttpClient, rootUrl: string, params?: GetRsaDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<RsaDeviceListResponse>> {
  const rb = new RequestBuilder(rootUrl, getRsaDevices.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {"style":"form","explode":true});
    rb.query('size', params.size, {"style":"form","explode":true});
    rb.query('sort', params.sort, {"style":"form","explode":true});
    rb.query('branch_id', params.branch_id, {"style":"form","explode":true});
    rb.query('include_disabled', params.include_disabled, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RsaDeviceListResponse>;
    })
  );
}

getRsaDevices.PATH = '/api/v1/rsa/devices';
